import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import styles from './ViewOnlyWarning.module.scss';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';

const ViewOnlyWarning = () => {
  const { selectedOption } = useSelectedIndex();

  const t = useTranslations();

  const canDownload =
    selectedOption?.effectivePermissions?.includes('Download');

  if (!selectedOption) {
    return null;
  }

  if (!canDownload && selectedOption.type === 'PremiumAccess') {
    return (
      <div
        className={styles.warningText}
        data-testid="view-only-warning"
      >
        {t('premium_access_view_only_tooltip')}
      </div>
    );
  }
  return null;
};

export default ViewOnlyWarning;
